import {Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {AsideAction} from '../../../store/aside.action';

@Component({
    selector: 'app-generic-aside',
    templateUrl: './generic-aside.component.html',
    styleUrls: ['./generic-aside.component.scss']
})

export class GenericAsideComponent implements OnInit {

    something: any;

    constructor(private store: Store) {
    }

    ngOnInit() {
    }

    close() {
        this.store.dispatch(AsideAction.CloseRight());
    }
}
